class EventService {

  constructor(ApiService, $q, EventSchema, Upload) {
    this.$q = $q;
    this.ApiService = ApiService;
    this.Upload = Upload;
    this.EventSchema = EventSchema;

    this.imageEndpoint = "/api/upload";

    this.deletedynamicLinkImageEndpoint = "/api/dynamiclinks/deleteimage";
  }

  /**
   * Get new empty event schema
   * @returns {*}
   */
  getNew() {
    return this.EventSchema;
  }

  getById(eventId, racedayId) {
    var self = this;

    return self.ApiService.get('/api/racedays/' + racedayId + '/events/' + eventId)
      .then((response) => {
        var event = response.data;
        event.location = event.location.id;

        //format returned array of dynamic links in to specific properties
        if (event.buttons) {
          if (event.buttons[0]) {
            event.dynamicLink1 = event.buttons[0];
          }
          if (event.buttons[1]) {
            event.dynamicLink2 = event.buttons[1];
          }
        }

        if (!event.dynamicLink1) {
          event.dynamicLink1 = { id: null, name: "", url: "", imageUrl: "" };
        }
        if (!event.dynamicLink2) {
          event.dynamicLink2 = { id: null, name: "", url: "", imageUrl: "" };
        }

        return event;
      });
  }

  getAllNonRacingEvents() {
    var self = this;

    return self.ApiService.get('/api/nonracingevents')
      .then((response) => { return response.data });
  }

  /**
   * Send new event to server
   * @param   {*}   event
   * @param   {Int} racedayId
   * @param   {*}   files
   *
   * @returns {*}
   */
  addNew(event, racedayId, files) {
    return this.submit(event, racedayId, files, 'post');
  }

  /**
   * Send edited event to server
   * @param   {*} event
   * @param   {Int} racedayId
   * @param   {*} files
   *
   * @returns {*}
   */
  update(event, racedayId, files, filesToRemove) {
    return this.submit(event, racedayId, files, 'put', filesToRemove);
  }

  /**
   * Submit event to server
   * @param   {*}         event
   * @param   {Int}       racedayId
   * @param   {*}         files
   * @param   {String}    mode
   *
   * @returns {*}
   */
  submit(event, racedayId, files, mode, filesToRemove) {

    var self = this;

    // save the images
    return self.addImage(event, files, 'header', filesToRemove).then(function (event) {

      // get object ready
      var readyData = self.stripUnnecessaryFields(event);

      // save the event
      var endpoint = '/api/racedays/' + racedayId + '/event';
      if (mode == 'put') {
        endpoint += '/' + event.id;
      }
      return self.ApiService[mode](endpoint, readyData).then(
        function (eventResponse) {
          event.id = eventResponse.data.id;
        }
      ).then(
        function () {
          return self.addImage(event, files, 'dynamicLink1', filesToRemove);
        }
      ).then(
        function (event) {
          if (event.dynamicLink1 && !!event.dynamicLink1.name.trim() && !!event.dynamicLink1.url.trim()) {
            return self.saveDynamicLink(event.id, racedayId, event.dynamicLink1)
              .then(function (dynamicLink1Response) {
                event.dynamicLink1 = dynamicLink1Response;
              });
          } else if (event.dynamicLink1.id) {
            return self.deleteDynamicLink(event.id, racedayId, event.dynamicLink1.id)
              .then(function () {
                event.dynamicLink1 = { id: null, name: "", url: "", imageUrl: "" };
              });
          }
        }
      ).then(
        function () {
          return self.addImage(event, files, 'dynamicLink2', filesToRemove);
        }
      ).then(
        function (event) {
          if (event.dynamicLink2 && event.dynamicLink2.name !== '' && event.dynamicLink2.url != '') {
            return self.saveDynamicLink(event.id, racedayId, event.dynamicLink2)
              .then(function (dynamicLink2Response) {
                event.dynamicLink2 = dynamicLink2Response;
              });
          } else if (event.dynamicLink2.id) {
            return self.deleteDynamicLink(event.id, racedayId, event.dynamicLink2.id)
              .then(function () {
                event.dynamicLink2 = { id: null, name: "", url: "", imageUrl: "" };
              });
          }
        }
      ).then(
        function () { return event; }
      );
    });
  }

  addImage(event, files, type, filesToRemove) {

    var self = this;
    if (files[type]) {
      var endpointType = type.toLowerCase().startsWith('dynamiclink') ? 'dynamic_link' : type;
      return self.Upload.upload({
        url: self.imageEndpoint + '/' + endpointType,
        data: { file: files[type] }
      }).then((response) => {
        if (response) {
          if (type == 'header') {
            // add image details to event object
            event.largeImageUrl = response.data.large_image.url;
            event.mediumImageUrl = response.data.medium_image.url;
          }
          else if (type == 'dynamicLink1') {
            event.dynamicLink1.imageUrl = response.data.image.url;
          }
          else if (type == 'dynamicLink2') {
            event.dynamicLink2.imageUrl = response.data.image.url;
          }
          return event;
        } else {
          return self.$q.reject({ type: 'image', field: type, message: type + ' image has incorrect dimensions' });
        }
      }).catch((response) => {
        var error = { type: 'image', field: type, message: "Unknown error saving the event or associated image" };
        if (response.data.error) {
          error.message = response.data.message;
        }
        return self.$q.reject(error);
      });
    }
    else {
      if (filesToRemove && filesToRemove['header']) {
        event.largeImageUrl = '';
        event.mediumImageUrl = '';
      }
      if (filesToRemove && filesToRemove['dynamicLink1']) {
        event.dynamicLink1.imageUrl = '';
      }
      if (filesToRemove && filesToRemove['dynamicLink2']) {
        event.dynamicLink2.imageUrl = '';
      }
      return self.$q.when(event);
    }

  }


  deleteEvent(eventId, racedayId) {
    var self = this;
    return self.ApiService._delete('/api/racedays/' + racedayId + '/events/' + eventId);
  }

  getNonRacedayEvents(racedayId) {
    var self = this;
    return self.ApiService.get('/api/racedays/' + racedayId + '/events')
      .then((response) => { return response.data });
  }

  stripUnnecessaryFields(event) {
    var formattedEvent = {
      "id": event.id,
      "name": event.name,
      "description": event.description,
      "largeImageUrl": event.largeImageUrl,
      "mediumImageUrl": event.mediumImageUrl,
      "websiteUrl": event.websiteUrl,
      "startTime": event.startTime,
      "endTime": event.endTime,
      "location": event.location,
      "active": event.active
    };
    return formattedEvent;
  }

  /**
    * Save dynamicLink on server
    * @param eventId
    * @param racedayId
    * @param dynamicLink
    * @returns {*}
    */
  saveDynamicLink(eventId, racedayId, dynamicLink) {
    var self = this;
    var readyData = self.stripUnnecessaryDynamicLinkFields(dynamicLink);
    if (dynamicLink.id && dynamicLink.id !== '' && dynamicLink.id > 0) {
      return self.ApiService.put('/api/racedays/' + racedayId + '/events/' + eventId + '/dynamiclink/' + dynamicLink.id, readyData);
    } else {
      return self.ApiService.post('/api/racedays/' + racedayId + '/events/' + eventId + '/dynamiclink', readyData);
    }
  }

  /**
    * Delete dynamicLink from server
    * @param eventId
    * @param racedayId
    * @param dynamicLinkId
    * @returns {*}
    */
  deleteDynamicLink(eventId, racedayId, dynamicLinkId) {
    var self = this;
    return self.ApiService._delete('/api/racedays/' + racedayId + '/events/' + eventId + '/dynamiclinks/' + dynamicLinkId);
  }

  stripUnnecessaryDynamicLinkFields(dynamicLink) {
    var formattedDynamicLink = {
      "id": dynamicLink.id,
      "name": dynamicLink.name,
      "url": dynamicLink.url,
      "imageUrl": dynamicLink.imageUrl,
      "type": "event"
    };
    return formattedDynamicLink;
  }

}

EventService.$inject = ['ApiService', '$q', 'EventSchema', 'Upload'];
export default EventService;
